import React, {useCallback} from 'react';
import {Button} from '@udemy-v2/react-core-components';
import {Loader} from '@udemy-v2/react-reveal-components';
import {BasicBarContentWithTruncation} from '@udemy-v2/react-smart-bar';
import {useShoppingListStore, ShoppingListType} from '@udemy-v2/api-shopping';
import {CoursePriceStore} from '@udemy-v2/react-course-pricing';

import {useSmartBarStore} from '@udemy-v2/react-smart-bar';
import styles from './cart-opt-in.module.scss';
import type {CouponStore} from '@udemy-v2/api-shopping';

interface CartOptInProps {
    couponStore?: CouponStore;
    coursePriceStore?: CoursePriceStore;
    onOptInSuccess?: () => void;
}

export function CartOptIn({couponStore, coursePriceStore, onOptInSuccess}: CartOptInProps) {
    const shoppingListStore = useShoppingListStore();
    const smartBarStore = useSmartBarStore();

    const handleOptInClick = useCallback(async () => {
        if (smartBarStore.optInApplied || smartBarStore.optInApplying) {
            return;
        }

        try {
            if (smartBarStore.data?.isOptInBar) {
                await smartBarStore.optIn();
                shoppingListStore.getShoppingList(ShoppingListType.CART);
                couponStore?._updateState?.();
                coursePriceStore?.reloadCourses?.();
            }

            onOptInSuccess?.();
        } catch (error) {
            console.error('Failed to apply opt-in:', error);
        }
    }, [smartBarStore, couponStore, coursePriceStore, onOptInSuccess, shoppingListStore]);

    if (!smartBarStore || !smartBarStore.data?.isOptInBar || smartBarStore.optInApplied) {
        return null;
    }

    const getButtonText = () => {
        if (smartBarStore.optInApplied) {
            return smartBarStore.data?.ctaAppliedText;
        }
        if (smartBarStore.optInApplying) {
            return <Loader color="inherit" overlay={true} className={styles.loader} />;
        }
        return smartBarStore.data?.ctaText;
    };

    const noop = () => {};

    return (
        <div className={styles.cartOptIn} data-purpose="cart-opt-in">
            <BasicBarContentWithTruncation
                data={smartBarStore.data}
                className={styles.cartOptInContent}
                onLinkClick={noop}
                onActionURLClick={noop}
            />
            <div>
                <Button
                    udStyle="ghost"
                    size="medium"
                    className={`${styles.optInCtaButton} ${
                        smartBarStore.data?.isOptInBar ? 'ud-link-underline' : ''
                    }`}
                    onClick={handleOptInClick}
                    disabled={smartBarStore.optInApplying}
                    data-purpose="cart-opt-in-cta"
                >
                    {getButtonText()}
                </Button>
            </div>
        </div>
    );
}
